import { render, staticRenderFns } from "./ResearchSingleCellSelector.vue?vue&type=template&id=526ee65d&scoped=true"
import script from "./ResearchSingleCellSelector.vue?vue&type=script&lang=js"
export * from "./ResearchSingleCellSelector.vue?vue&type=script&lang=js"
import style0 from "./ResearchSingleCellSelector.vue?vue&type=style&index=0&id=526ee65d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526ee65d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('526ee65d')) {
      api.createRecord('526ee65d', component.options)
    } else {
      api.reload('526ee65d', component.options)
    }
    module.hot.accept("./ResearchSingleCellSelector.vue?vue&type=template&id=526ee65d&scoped=true", function () {
      api.rerender('526ee65d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/singleCellBrowser/ResearchSingleCellSelector.vue"
export default component.exports